import React, { useCallback } from 'react';
import { ButtonMenu } from '@ann/web-components';
import { DASHBOARD_CARD_COPY } from '../../constants/dashboardBuilderCopy';

const DashboardCardMenu = ({
  onEdit,
  onShare,
  onArchive,
  onDuplicate,
  isArchived = false,
}) => {
  const { menu: menuCopy } = DASHBOARD_CARD_COPY;

  const handleChange = useCallback(
    (value) => {
      if (value === 'edit') onEdit?.();
      if (value === 'share') onShare?.();
      if (value === 'archive') onArchive?.();
      if (value === 'duplicate') onDuplicate?.();
    },
    [onEdit, onShare, onArchive, onDuplicate]
  );

  const handleStopPropagation = useCallback((e) => {
    e.stopPropagation();
  }, []);

  return (
    <ButtonMenu
      customIcon="dotsMenu"
      disableEffects
      type="tertiary"
      size="small"
      label=""
      menuPosition="bottom"
      alignMenu="right"
      onClick={handleStopPropagation}
      onChange={handleChange}
      width="180px"
    >
      <ButtonMenu.Menu icon={true}>
        <ButtonMenu.Item
          label={menuCopy.edit}
          value="edit"
          icon="edit"
        />
        <ButtonMenu.Item
          label={menuCopy.share}
          value="share"
          icon="share"
        />
        <ButtonMenu.Item
          label={isArchived ? menuCopy.unarchive : menuCopy.archive}
          value="archive"
          icon="inventory_2"
        />
        <ButtonMenu.Item
          label={menuCopy.duplicate}
          value="duplicate"
          icon="copy"
        />
      </ButtonMenu.Menu>
    </ButtonMenu>
  );
};

export default DashboardCardMenu;
